<template>
  <section class="featured">
    <div class="container">
      <a-typography-title :level="1">
        多种数字人形象交互
      </a-typography-title>
      <div class="box_list">
        <div v-for="(item,index) in expand.list" ref="item" class="item" :class="[`i_${index+1}`,index+1===expand.active?'active':'']">
          <a-typography-title :level="5">
            {{ item.title }}
          </a-typography-title>
          <a-typography-paragraph>
            <p v-for="v in item.text">
              <!-- <img alt="" :src="v.icon" /> -->
              {{ v.text }}
            </p>
          </a-typography-paragraph>
        </div>
      </div>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3" @click="clickToAidigitalHuman()">
          免费试用
        </a-button>
        <a-button class="button_n_2"  type="link" 
                 @click="$Store.Page().openModal('modalFormCollection','productAidigitalHuman')">
         联系我们
        </a-button>
      </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";

export default {
  name: "plan_featured",
  data(): DataInterface {
    return {
      expand: {
        active: 1,
        list: [
          {
            title: "3D实时互动数字人",
            text: [
              {
                text: "3D数字人定制，真实复刻人物",
              },
              {
                text: "3D数字人在线服务支持",
              },
            ],
          },
          {
            title: "IP实时互动数字人",
            text: [
              {
                text: "IP数字人定制",
              },
              {
                text: "IP数字人在线服务支持",
              },
            ],
          },
          {
            title: "多模态输入支持",
            text: [
              {
                text: "支持人脸识别，识别当前屏幕前用户",
              },
              {
                text: "支持图片等媒体信息输入",
              },
            ],
          },
          {
            title: "数字人声音克隆",
            text: [
              {
                text: "支持数字人音色自定义",
              },
            ],
          },
        ],
      },
    };
  },
  mounted(): void {
    this.listenMouseOver();
  },
  methods: {
    /**
     * 点击去AI数字人
     */
    clickToAidigitalHuman(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://aiavatars-monn34rc.apps.galaxy-future.com/");
    },
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener(
          "mouseover",
          () => {
            this.expand.active = i + 1;
          },
          false
        );
      });
    },

    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd");
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/productSchedulX/";
@border: 1px solid @color_14;

.featured {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;

  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.box_list {
  overflow: hidden;
  position: relative;
  margin: @margin 0 0;
  border: @border;
  .borderBox();
  .shadow(0 0 20px fade(@color_black, 4));
}

.item {
  @style: width @time, background @time;
  float: left;
  overflow: hidden;
  position: relative;
  width: 20%;
  height: 400px;
  .bg("@{image}worth_item_bg.jpg");
  background-size: cover;
  //.transition(@style);

  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      border-left: if(@i>1, @border, none);
      border-right: if(@i<4, @border, none);

      h5.ant-typography::before {
        .bg("@{src_image}page/productAidigitalHuman/human_icon_@{i}.png", 160px, 150px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);

  &.active {
    width: 40%;
    background: @color_white;

    h5.ant-typography {
      .transform(translate(-50%, calc(~"-50% - 85px")));
    }

    div.ant-typography {
      opacity: 1;
      .transform(translate(-50%, -80px));
    }
  }

  h5.ant-typography {
    .center();
    z-index: 1;
    margin: 0;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transition(transform @time);
    width: 100%;

    &::before {
      content: "";
      display: block;
      margin: 0 auto 10px;
    }
  }

  div.ant-typography {
    @style: opacity @time, transform @time;
    .position(absolute, auto, auto, -80px, 50%);
    z-index: 1;
    width: 100%;
    max-width: 300px;
    height: 180px;
    margin: 0 auto;
    .font(justify, @text+@line, @color_13, @text);
    opacity: 0;
    .transform(translate(-50%, 0));
    .transition(@style);

    p {
      text-align: center;
      position: relative;
      margin: 0 0 5px;
      .borderBox();

      img {
        display: block;
        .position(absolute, 3px, auto, auto, 0);
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_list {
    overflow: initial;
    border: none;
    .shadow(none);
  }

  .item {
    float: none;
    width: 100% !important;
    max-width: 360px;
    height: auto;
    padding: 160px 0 20px;
    margin: 20px auto 0;
    background: @color_white;
    border: @border !important;
    .shadow(0 0 20px fade(@color_black, 4));

    &:nth-child(1) {
      margin-top: 0;
    }

    .loop(@i) when (@i<=4) {
      &.i_@{i} {
        @style: 0.6px;

        h5.ant-typography::before {
          .bg("@{image}worth_icon_@{i}.png", 160px*@style, 150px*@style, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);

    h5.ant-typography {
      .position(top, 20px);
      .transform(translate(0, 0)) !important;
    }

    div.ant-typography {
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: auto;
      opacity: 1 !important;
      .transform(translate(0, 0)) !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .featured {
    .container {
      padding: @space_mo 0;
    }
  }

  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }

  .item {
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }

    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }

  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>